module.exports = __webpack_public_path__ + "img/nav_footer_3_h.6ebf77da.png";